export const shockHistoryLevel = {
  lagre: 1,
  medium: 2,
  small: 3,
};
